import React , { Component,Fragment, useEffect , useState,useRef} from 'react';
import './style.css';
import { useHistory ,useLocation,Link} from "react-router-dom"
import { Layout, Menu, Breadcrumb,Table , Button, Space,Form,Input,Row,Col,Checkbox, Divider,Card,Radio,Spin,Select} from 'antd';
import { MinusCircleOutlined,PlusOutlined,SearchOutlined ,MoreOutlined,SyncOutlined,EditOutlined } from '@ant-design/icons';
import { FaRegEdit,FaEdit,FaRegSave } from "react-icons/fa";
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { getDepartment, getDepartmentSelector,updateDepartmentAsyn,clearState } from './editDepartmentSlice';
import { getUserDepartments } from '../Department/departmentSlice';
import toast, { Toaster , ToastBar} from 'react-hot-toast';
const { Header, Content, Footer } = Layout;
const { Search ,TextArea} = Input;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
// const plainOptions = ['Branch', 'Independent Office', 'Independent Directorate'];
// const defaultCheckedList = [];

export default function EditDepartment() {

  const plainOptions = ['Branch', 'Independent Office', 'Independent Directorate'];
  const defaultCheckedList = ['Branch'];

  const [isDepReadonly, setDepReadonly] = React.useState(true);
  const [isBrReadonly, setBrReadonly] = React.useState([]);
  const [isToast, setToast] = React.useState(false);


  const inputAddBranch = React.useRef(null);
  const [departmentObj, setDepartment] = React.useState({});
  const [isLoading, setLoading] = React.useState(false);
  const [checkedList, setCheckedList] = React.useState(defaultCheckedList);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  const [directorate, setDirectorate] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory()
  const location = useLocation();

  const [refno, setRefNo] = React.useState('');
  const [brefno, setbRefNo] = React.useState('');
  const [state, setState] = useState({})

  const [branchRef1, setBranchRef1] = React.useState(null);
  const [branchRef, setBranchRef] = useState([]);
  const [branchRefArr, setBranchRefArr] = useState([]);

  const [branchDirRef, setBranchDirRef] = useState([]);

  const [brDirectorate, setBrDirectorate] = React.useState(false);
  const [brDirectorateName, setBrDirRefname] = React.useState(null);
  const [brDirectorateDes, setBrDireDesRef] = useState(null);
  const [brDirectorateArr, setbrDirRefArr] = useState([]);

  const [drrefno, setdrRefNo] = React.useState('');
  const [iorefno, setioRefNo] = React.useState('');

  let branchKey = 1;
 
  let branchDirKey = 1;
  const [branch1, setBranch1] = React.useState('');
  const [branch1Des, setBranch1Des] = React.useState('');
  const [branch1Ref, setBranch1Ref] = React.useState('');
   const { isFetching, isSuccess, isError,isUpdated, errorMessage,department } = useSelector(
    getDepartmentSelector
  );

  const [form] = Form.useForm()

 useEffect(() => {
   // console.log(location.state.departmentName);
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getDepartment(location.state.departmentName));
  
  }, []);

  useEffect(() => {

    if (isUpdated) {
      setLoading(false);
      setDepReadonly(true);
    }
   
    if (isError) {
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
    }
    if (isSuccess) {
     
 //console.log(department);
      setTimeout(() => {
        setDepartment(department);
        //console.log(department)
        form.setFieldsValue({
          name: department.name,
          description:department.description[0],
          branch:department.branch,
          independentOffice:department.independentOffice,
          independentDirectorate:department.independentDirectorate,
        });
       // const plainOptions = ['Branch', 'Independent Office', 'Independent Directorate'];
       let switchArry = [];
       if(department.branch){
          switchArry.push('Branch');
        }

        if(department.independentOffice){
          switchArry.push('Independent Office');
        }

        if(department.independentDirectorate){
          switchArry.push('Independent Directorate');
        }
       setCheckedList(switchArry);
      
        if(department.referenceNumber){
          let dref = [];
          department.referenceNumber.forEach(val => {
            dref.push({referenceNumber:val})
            //console.log(val)
           });
           form.setFieldsValue({
            arr_referenceNumber: dref
          });
        }
        //.......Branch & Directorate......//
        if(department.branch_data){
          let bData = [];
          let j = 0;
          department.branch_data.forEach(val => {
            setBranchDir('bref'+j)
            let brref = [];
            if(val.b_referenceNumber){
            val.b_referenceNumber.forEach(val => {
              brref.push({b_referenceNumber:val})
             });
             }

             let bdDir = [];
             if(val.bd_directorates){
              val.bd_directorates.forEach(bdval => {
                let bdrref = [];
                if(bdval.bd_referenceNumber){
                  bdval.bd_referenceNumber.forEach(v => {
                  bdrref.push({bd_referenceNumber:v})
                });
                }

                bdDir.push({ bd_name: bdval.bd_name, arr_bd_referenceNumber: bdrref.length?bdrref:[{bd_referenceNumber:''}], bd_description: bdval.bd_description[0] })
               });
               }


            bData.push({ code:val.code,departmentType:val.departmentType,departmentType_name:val.departmentType_name,b_name: val.b_name, arr_b_referenceNumber: brref.length?brref:[{b_referenceNumber:''}], b_description:  val.b_description[0],b_directorate:val.b_directorate,bd_directorates:bdDir })
            j++;
            //console.log(val)
           });
           form.setFieldsValue({
            branch_data: bData
          });
        }
        //.......Branch & Directorate......//

       //.......Independent office......//
         if(department.io_independentOffices){
          let ioData = [];
          department.io_independentOffices.forEach(val => {
            let ioref = [];
            if(val.io_referenceNumber){
            val.io_referenceNumber.forEach(val => {
              ioref.push({io_referenceNumber:val})
             });
             }
             ioData.push({ code:val.code,departmentType:val.departmentType,departmentType_name:val.departmentType_name,io_name: val.io_name, arr_io_referenceNumber: ioref.length?ioref:[{io_referenceNumber:''}], io_description:  val.io_description[0]})
            //console.log(val)
           });
           form.setFieldsValue({
            io_independentOffices: ioData
          });
        }
        //.......Independent office......//

        //.......Independent Directorate......//
        if(department.id_directorates){
          let idData = [];
          department.id_directorates.forEach(val => {
            let idref = [];
            if(val.id_referenceNumber){
            val.id_referenceNumber.forEach(val => {
              idref.push({id_referenceNumber:val})
             });
             }
             idData.push({ code:val.code,departmentType:val.departmentType,departmentType_name:val.departmentType_name,id_name: val.id_name, arr_id_referenceNumber: idref.length?idref:[{id_referenceNumber:''}], id_description:  val.id_description[0]})
            //console.log(val)
           });
           form.setFieldsValue({
            id_directorates: idData
          });
        }
        //.......Independent Directorate......//
        setLoading(false);
      }, 1000);
      
    }
    
  }, [isError, isSuccess,isUpdated,setLoading,setDepartment,form,setDepReadonly,setToast]);

  const setBranchDir = (name) => {
    setState(prev =>({
      ...prev,
      [name] : !false
  }));
   
  }

  const setDefaultSelection = list => { 
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < plainOptions.length);
  };

  const onChange = list => { 
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < plainOptions.length);
  };
 

  var isBranchChecked = checkedList.length?checkedList.filter((val) => val.includes('Branch')).length?true:false:false;
  var isIndOffChecked = checkedList.length?checkedList.filter((val) => val.includes('Independent Office')).length?true:false:false;
  var isIndDirChecked = checkedList.length?checkedList.filter((val) => val.includes('Independent Directorate')).length?true:false:false;

  const onFinish = values => {

    //console.log(values)

   let referenceNumber = values.arr_referenceNumber.map(function({referenceNumber}){
       return referenceNumber;
   });
   let brData = [];
   let indOffArr = [];
   let indDIRArr = [];

   if(values.branch_data){
    let branchdata = values.branch_data.map((v,i)=>{
     
      let b_referenceNumber = v.arr_b_referenceNumber.map(function({b_referenceNumber}){
        return b_referenceNumber;
      });
      let bdDir = [];
     if(v.bd_directorates){
      let bdDirdata = v.bd_directorates.map((d,di)=>{

        let bd_referenceNumber = d.arr_bd_referenceNumber.map(function({bd_referenceNumber}){
          return bd_referenceNumber;
        });
        let bdObject = {bd_name:d.bd_name,bd_description:d.bd_description,bd_referenceNumber:bd_referenceNumber};
        bdDir.push(bdObject);
      });
     }
      
      let bObject = {b_name:v.b_name,b_description:v.b_description,b_referenceNumber:b_referenceNumber,b_directorate:v.b_directorate,bd_directorates:bdDir}
      brData.push(bObject);
    });
   }


   if(values.io_independentOffices){
    let iodata = values.io_independentOffices.map((v,i)=>{
     
      let io_referenceNumber = v.arr_io_referenceNumber.map(function({io_referenceNumber}){
        return io_referenceNumber;
      });
      
      let ioObject = {io_name:v.io_name,io_description:v.io_description,io_referenceNumber:io_referenceNumber}
      indOffArr.push(ioObject);
    });
   }

   if(values.id_directorates){
    let iddata = values.id_directorates.map((v,i)=>{
     
      let id_referenceNumber = v.arr_id_referenceNumber.map(function({id_referenceNumber}){
        return id_referenceNumber;
      });
      
      let ioObject = {id_name:v.id_name,id_description:v.id_description,id_referenceNumber:id_referenceNumber}
      indDIRArr.push(ioObject);
    });
   }


   var isBranchChecked = checkedList.length?checkedList.filter((val) => val.includes('Branch')).length?true:false:false;
   var isIndOffChecked = checkedList.length?checkedList.filter((val) => val.includes('Independent Office')).length?true:false:false;
   var isIndDirChecked = checkedList.length?checkedList.filter((val) => val.includes('Independent Directorate')).length?true:false:false;
    let data = {
      "name": values.name,
      "referenceNumber": referenceNumber,
      "description": values.description,
      "branch": isBranchChecked?true:false,
      "branch_data":isBranchChecked?brData:[],
     "independentOffice": isIndOffChecked ?true:false,
     "io_independentOffices":isIndOffChecked?indOffArr:[],
     "independentDirectorate": isIndDirChecked ?true:false,
     "id_directorates":isIndDirChecked?indDIRArr:[],
  };

  // setLoading(true);
  // dispatch(addDepartment(data));

  }

  const onFinishFailed = (errorInfo) => {
    
    //console.log('Failed:', errorInfo);
  };

  const removeDepartmentReadonly = () => {
     setDepReadonly(!isDepReadonly);
  }

  const updateDepartment = () => {
    dispatch(clearState());
   let name =  form.getFieldValue('name');
   let arr_referenceNumber =  form.getFieldValue('arr_referenceNumber');
   let referenceNumber = arr_referenceNumber.map(function({referenceNumber}){
    return referenceNumber;
   });
   let description =  form.getFieldValue('description');
   let data = {
    "departmentName":departmentObj.name,
    "change":{
        "name":name,
        "referenceNumber":referenceNumber,
        "description":description
    }
};

    setLoading(true);   
    dispatch(updateDepartmentAsyn(data));
  }

  const removeBranchReadonly = (name) => {

    setState(prev =>({
      ...prev,
      [name] : !name
  }));
   
      //  let array = [...isBrReadonly]; // make a separate copy of the array
      //  let index = array.indexOf(val)

      //  if (index == -1) {
      //   array.push(val); 
      //   setBrReadonly(array);
      // }
      // else{
      //    array.splice(index, 1);
      //    setBrReadonly(array);
      // }
     
 }
 
 let formbranch =  form.getFieldValue('branch_data');
 let originalbranch = department && department.branch_data ? department.branch_data:[];
 let originalbranchRef = department && department.branch_data ? department.branch_data:[];
  // console.log(originalbranchRef.length && originalbranchRef[0].b_referenceNumber.length)
  return (
    <>
   <Container>
   <Breadcrumb style={{ margin: '16px 0',paddingLeft:50,marginBottom:0 }} separator=">">
        <Breadcrumb.Item>Departments</Breadcrumb.Item>
        <Breadcrumb.Item>Edit Department</Breadcrumb.Item>
    </Breadcrumb>

   <div className="site-layout-content" style={{marginTop:0,paddingTop:0}}>
   {isToast &&
          <Toaster 
            toastOptions={{
              className: '',
              style: {
                border: '1px solid #713200',
                padding: '16px',
                color: '#713200',
                marginTop:50
              },
            }}
            >
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <>
                      {icon}
                      {message}
                      {t.type !== 'loading' && (
                        <button onClick={() => toast.dismiss(t.id)}>X</button>
                      )}
                    </>
                  )}
                </ToastBar>
              )}
            </Toaster>
         }
  <div style={{padding:24,paddingTop:16}}>
  <Spin indicator={antIcon} style={{textAlign:'center',width:'100%',position:'fixed',zIndex:1,left:0,right:0,top:'45%',bottom:0}} spinning={isLoading} />
  <div>
          <Row style={{paddingTop:35,paddingBottom:20,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderTop:'1px solid #dfe0eb',borderBottom:'2px solid #e8e8e8'}}>
            <Col span="6"></Col>
            <Col span="9" >
              <h1 style={{fontWeight:'bold',fontStyle:'normal',fontSize:24}}>Edit Department</h1>
            </Col>
            <Col span="9" style={{paddingLeft:25}}>
           
            </Col>
          </Row>
          <Form
              layout="vertical"
               labelCol={{ span: 16 }}
               wrapperCol={{ span: 16}}
               onFinish={onFinish}
               onFinishFailed={onFinishFailed}
               form={form}
              >
          <Row  style={{paddingTop:24,paddingBottom:80,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb',marginBottom:10}}>
          <Col span="6"></Col>
            <Col span="18"  >
                 <Form.Item >
                 <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Department Details &nbsp;&nbsp;
                 <Button type="link" size={'middle'} style={{fontSize:20,padding: '4px 5px'}} onClick={ () => removeDepartmentReadonly()}>
                      {isDepReadonly?<FaRegEdit />:<FaEdit />}
              </Button>
              <Button type="link" size={'middle'} style={{fontSize:20,padding: '4px 5px'}} onClick={ () => updateDepartment()}>
                       {!isDepReadonly && <FaRegSave />}
              </Button>
                 </h2>
              </Form.Item>
              <Form.Item 
              rules={[{ required: true, message: 'Name is required' }]}
              requiredMark={'optional'}
              name={'name'} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Name*</p>}  >
                <Input className="formInput" placeholder="" readOnly={isDepReadonly}/>
              </Form.Item>
{/* 
              <Form.Item 
              style={{marginTop:30}}
              rules={[{ required: true, message: 'Reference no is required' }]}
              requiredMark={'optional'}
              name={'referenceNumber'} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Reference No*</p>}  >
                <Input className="formInput" placeholder="" />
              </Form.Item> */}

              <Form.List name="arr_referenceNumber" initialValue={[{referenceNumber:''}]} >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Form.Item
                    {...restField}
                    name={[name,'referenceNumber']}
                    
                      label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => isDepReadonly?'':add()} type="link">{!isDepReadonly?'+ ADD':''}</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => isDepReadonly?'':remove(name)} type="link">{!isDepReadonly ?<MinusCircleOutlined  />:''}</Button></Col></Row>}
                      fieldKey={[fieldKey, 'referenceNumber']}
                      rules={[{ required: true, message: 'Reference No is required' }]}
                      requiredMark={'optional'}
                    >
                      <Input className="formInput" placeholder="" readOnly={isDepReadonly}/>
                    </Form.Item>
                  ))}
                </>
              )}
             </Form.List>

              <Form.Item
                name={'description'}
                label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
              >
                <TextArea rows={4} className="formInput" placeholder="" readOnly={isDepReadonly}/>
              </Form.Item>

              <Form.Item
                name={'branch'}
                // initialValue={['branch']}
                 valuePropName={departmentObj.branch?['branch']:[]}
                label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>What do you want to add?</p>}
              >
               <CheckboxGroup  options={plainOptions} value={checkedList} onChange={onChange} />
              </Form.Item>
              <>
              {isBranchChecked &&
              <>
              <Form.Item >
                <hr style={{borderTop:"1px solid #dfe1e6"}}/>
              </Form.Item>

              <Form.List name="branch_data" initialValue={[{ b_name: '', b_referenceNumber: '', b_description: '',b_directorate:true }]}>
              {(fields, { add, remove }) => (
                <>
                <Form.Item >
                 <Row  style={{width:'100%'}}><Col span={18}> <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Branch</h2></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:-5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  ref={inputAddBranch} type="link">+ ADD BRANCH</Button></Col></Row>
              </Form.Item>
              

            {fields.map(({ key, name, fieldKey, ...restField }) => (
               <>
                <Form.Item >
                    <h2 style={{fontWeight:'400',fontStyle:'normal',fontSize:20}}>Branch {key+1}  &nbsp;&nbsp;
                    {/* {formbranch.indexOf(key) == originalbranch.indexOf(key) */}
                    {/* {originalbranch.length > 0 && originalbranch.indexOf(key)!=-1 && originalbranch.indexOf(key) == key
                    ?<>
                    <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => removeBranchReadonly(key)}>
                            {isBrReadonly.includes(key)==false?<FaRegEdit />:<FaEdit />}
                    </Button>
                    <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => updateDepartment()}>
                            {isBrReadonly.includes(key)==true && <FaRegSave />}
                    </Button>
                     </>
                    :<>
                    &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  />
                     </>
                    } */}

                     {state['bref'+name]
                    ?<>
                    <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => removeBranchReadonly('bref'+name)}>
                            {isBrReadonly.includes(key)==false?<FaRegEdit />:<FaEdit />}
                    </Button>
                    <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => updateDepartment()}>
                            {isBrReadonly.includes(key)==true && <FaRegSave />}
                    </Button>
                     </>
                    :<>
                    &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  />
                     </>
                    }
                    
                    {/* <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => removeBranchReadonly('bref'+name)}>
                            {isBrReadonly.includes(key)==false?<FaRegEdit />:<FaEdit />}
                    </Button>
                    <Button type="link" size={'middle'} style={{position:'relative',top:2,fontSize:20,padding: '4px 5px'}} onClick={ () => updateDepartment()}>
                            {isBrReadonly.includes(key)==true && <FaRegSave />}
                    </Button>
                    &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /> */}
                    </h2>
                  </Form.Item>
                  <Form.Item  style={{ marginBottom: 0 }}>
    
                  <Form.Item 
                  {...restField}
                  name={[name, 'b_name']}
                  rules={[{ required: true, message: 'Name is required' }]}
                  requiredMark={'optional'}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Name*</p>}  >
                    {/* {originalbranch.length == key+1
                    ?<Input className="formInput" id={'br'+key} placeholder="" readOnly={isBrReadonly.length && isBrReadonly.includes(key) == true?false:true} />
                    :<Input className="formInput"  placeholder=""  />
                    } */}
                    <Input className="formInput"  placeholder="" readOnly={state['bref'+name]?true:false} />
                  </Form.Item>

                  {/* <Form.Item
                  {...restField}
                  name={[name, 'b_referenceNumber']}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                    label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}></Col></Row>}
                  
                  >
                    <Input className="formInput" placeholder=""  />
                  </Form.Item> */}
                  

                  <Form.List name={[name, 'arr_b_referenceNumber']}  initialValue={[{b_referenceNumber:''}]}
                  >

                  {(b_referenceNumber, { add, remove }) => (
                      <>
                  {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                  <Col style={{textAlign:'right'}} span={6}>
                  <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                  </Col>
                  </Row> */}
                    {b_referenceNumber.map(({ key, name, bfieldKey, ...brestField }) => (
                    <Form.Item
                    {...brestField}
                    name={[name,'b_referenceNumber']}
                    rules={[{ required: true, message: 'Reference No is required' }]}
                     requiredMark={'optional'}
                      style={{ display: 'inline-block', width: key==0?'calc(50% - 8px)':'99%', margin: key==0?'0 8px':0 }}
                      label={key==0?<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No* </p></Col><Col span={6} style={{textAlign:'right'}}> <Button style={{marginBottom:-5,marginTop:-10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button></Col></Row>:<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                    >
                      <Input className="formInput" placeholder=""  />
                    {/* {originalbranchRef.length > 0 && originalbranchRef[0].b_referenceNumber.length < key+1
                    ?<Input className="formInput"  placeholder="" readOnly={isBrReadonly.length && isBrReadonly.includes(key) == true?false:true} />
                    :<Input className="formInput"  placeholder=""  />
                    } */}
                    </Form.Item>
                    ))}

                      </>
                  )}

                  </Form.List>
                  
                  </Form.Item>
    
                  <Form.Item
                  {...restField}
                  name={[name, 'b_description']}
                    label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                  >
                    <TextArea rows={4} className="formInput" placeholder="" readOnly={state['bref'+name]?true:false} />
                  </Form.Item>

                  <Form.Item
                   {...restField}
                   name={[name, 'b_directorate']}
                   //initialValue={true}
                label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Do you want to add Directorate?</p>}
                >
                <Radio.Group    defaultValue={true} >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}  >No</Radio>
                </Radio.Group>
                </Form.Item>

                <Form.Item
                   {...restField}
                  // name={[name, 'bd_directorates']}
                    label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}></p>}
                    // shouldUpdate={(prevValues, currentValues) => {
                    //   console.log('prevValues')
                    //  console.log(prevValues)
                    //  console.log('currentValues')
                    //  console.log(currentValues)
                    // }}
                     shouldUpdate={(prevValues, currentValues) =>  prevValues.branch_data[key].b_directorate && prevValues.branch_data[key].b_directorate !== currentValues.branch_data[key].b_directorate && currentValues.branch_data[key].b_directorate}
                    //shouldUpdate={(prevValues, currentValues) => currentValues.branch_data[key] && currentValues.branch_data[key].b_directorate==true}
                 >
                   {({ getFieldValue }) =>
              getFieldValue('branch_data')[key] ?
            getFieldValue('branch_data')[key].b_directorate === true ?  (
            <Form.List  name={[name, 'bd_directorates']}  initialValue={[{ bd_name: '', bd_referenceNumber: '', bd_description: '' }]}>
            {(bd_directorates, { add, remove }) => {
              
              return (
                <>
                <Form.Item >
                  <Row  style={{width:'100%'}}><Col span={16}> <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Directorate</h2></Col><Col style={{textAlign:'right'}} span={8}><Button style={{marginBottom:-2,marginTop:-5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}   type="link">+ ADD DIRECTORATE</Button></Col></Row>
                </Form.Item>

                {bd_directorates.map(nickname => (
                  <>
                  <span>
                  <Form.Item >
                    <h2 style={{fontWeight:'400',fontStyle:'normal',fontSize:20}}>Directorate {nickname.key+1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(nickname.name)}  /></h2>
                  </Form.Item>
                  <Form.Item  style={{ marginBottom: 0 }}>

                  <Form.Item 
                  {...nickname}
                  name={[nickname.name, 'bd_name']}
                  rules={[{ required: true, message: 'Name is required' }]}
                     requiredMark={'optional'}
                  initialValue={''}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Name*</p>}  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item>

                  {/* <Form.Item
                  {...nickname}
                  name={[nickname.name, 'bd_referenceNumber']}
                  initialValue={' '}
                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                    label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item> */}

                  <Form.List name={[nickname.name, 'arr_bd_referenceNumber']}
                  initialValue={[{bd_referenceNumber:''}]}
                  >

                  {(arr_bd_referenceNumber, { add, remove }) => (
                      <>
                  {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                  <Col style={{textAlign:'right'}} span={6}>
                  <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                  </Col>
                  </Row> */}
                    {arr_bd_referenceNumber.map(({ key, name, fieldKey, ...brestField }) => (
                    <Form.Item
                    {...brestField}
                    name={[name,'bd_referenceNumber']}
                    rules={[{ required: true, message: 'Reference No is required' }]}
                     requiredMark={'optional'}
                      //style={{ display: 'inline-block', width: '99%' }}
                      style={{ display: 'inline-block', width: key==0?'calc(50% - 8px)':'99%', margin: key==0?'0 8px':0 }}
                      //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                      label={key==0?<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}> <Button style={{marginBottom:-5,marginTop:-10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button></Col></Row>:<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                    >
                      <Input className="formInput" placeholder="" />
                    </Form.Item>
                    ))}

                      </>
                  )}

                  </Form.List>

                  </Form.Item>

                  <Form.Item
                   {...nickname}
                   name={[nickname.name, 'bd_description']}
                   initialValue={' '}
                    label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                  >
                    <TextArea rows={4} className="formInput" placeholder="" />
                  </Form.Item>
                  </span>
                  </>
                ))}
                </>
            )}}
          </Form.List>
          ) : null
          : null
        }
                   
                  </Form.Item>
    
                              
                  <br/>
                    <>

                    </>
                    </>
                  ))}
                </>
              )}
             </Form.List>
              </>
              }
             </>
             <br/>
             <>
              {isIndOffChecked &&
              <>
              <Form.Item >
                <hr style={{borderTop:"1px solid #dfe1e6"}}/>
              </Form.Item>
              
              <Form.List name="io_independentOffices" initialValue={[{io_name:'',io_referenceNumber:'',io_description:''}]}>
              {(fields, { add, remove }) => (
                <>
                      <Form.Item >
                      <Row  style={{width:'100%'}}><Col span={12}> <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Independent Office</h2></Col><Col style={{textAlign:'right'}} span={12}><Button style={{marginBottom:-2,marginTop:-5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  ref={inputAddBranch} type="link">+ ADD INDEPENDENT OFFICE</Button></Col></Row>
                      </Form.Item>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                      <>
                      <Form.Item >
                      <h2 style={{fontWeight:'400',fontStyle:'normal',fontSize:20}}>Independent Office {key+1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></h2>
                      </Form.Item>
                      <Form.Item  style={{ marginBottom: 0 }}>
              
                      <Form.Item 
                      {...restField}
                      name={[name, 'io_name']}
                      rules={[{ required: true, message: 'Name is required' }]}
                     requiredMark={'optional'}
                      style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Name*</p>}  >
                      <Input className="formInput" placeholder="" />
                      </Form.Item>

                      {/* <Form.Item
                      {...restField}
                      name={[name, 'io_referenceNumber']}
                      initialValue={' '}
                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                        label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                      >
                        <Input className="formInput" placeholder="" />
                      </Form.Item> */}
              
                      <Form.List name={[name, 'arr_io_referenceNumber']} initialValue={[{io_referenceNumber:''}]}>
              
                      {(arr_io_referenceNumber, { add, remove }) => (
                      <>
                      {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                      <Col style={{textAlign:'right'}} span={6}>
                      <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                      </Col>
                      </Row> */}
                      {arr_io_referenceNumber.map(({ key, name, bfieldKey, ...brestField }) => (
                      <Form.Item
                      {...brestField}
                      name={[name,'io_referenceNumber']}
                    rules={[{ required: true, message: 'Reference No is required' }]}
                     requiredMark={'optional'}
                      style={{ display: 'inline-block', width: key==0?'calc(50% - 8px)':'99%', margin: key==0?'0 8px':0 }}
                      label={key==0?<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}> <Button style={{marginBottom:-5,marginTop:-10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button></Col></Row>:<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                      //style={{ display: 'inline-block', width: '98%', margin: '0 8px' }}
                      //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right',paddingRight:1}} span={6}>&nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                      >
                      <Input className="formInput" placeholder="" />
                      </Form.Item>
                      ))}
              
                      </>
                      )}
              
                      </Form.List>
              
                      </Form.Item>
              
                      <Form.Item
                      {...restField}
                      name={[name, 'io_description']}
                      label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                      >
                      <TextArea rows={4} className="formInput" placeholder="" />
                      </Form.Item>
                      <>
                      </>
                      </>
                  ))}
                </>
              )}
              </Form.List>
              </>
              }
             </>
              <br/>
              <>
              {isIndDirChecked &&
               <>
               <Form.Item >
                 <hr style={{borderTop:"1px solid #dfe1e6"}}/>
               </Form.Item>
               
               <Form.List name="id_directorates" initialValue={[{id_name:'',id_referenceNumber:'',id_description:''}]}>
               {(fields, { add, remove }) => (
                 <>
                       <Form.Item >
                       <Row  style={{width:'100%'}}><Col span={12}> <h2 style={{fontWeight:'bold',fontStyle:'normal',fontSize:22}}>Independent Directorate</h2></Col><Col style={{textAlign:'right'}} span={12}><Button style={{marginBottom:-2,marginTop:-5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  ref={inputAddBranch} type="link">+ ADD INDEPENDENT DIRECTORATE</Button></Col></Row>
                       </Form.Item>
                       {fields.map(({ key, name, fieldKey, ...restField }) => (
                       <>
                       <Form.Item >
                       <h2 style={{fontWeight:'400',fontStyle:'normal',fontSize:20}}>Independent Directorate {key+1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></h2>
                       </Form.Item>
                       <Form.Item  style={{ marginBottom: 0 }}>
               
                       <Form.Item 
                       {...restField}
                       name={[name, 'id_name']}
                       rules={[{ required: true, message: 'Name is required' }]}
                       requiredMark={'optional'}
                       style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0}}>Name*</p>}  >
                       <Input className="formInput" placeholder="" />
                       </Form.Item>

                      {/* <Form.Item
                      {...restField}
                      name={[name, 'id_referenceNumber']}
                      initialValue={' '}
                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                        label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p>}
                      >
                        <Input className="formInput" placeholder="" />
                      </Form.Item> */}
               
                       <Form.List name={[name, 'arr_id_referenceNumber']} initialValue={[{id_referenceNumber:''}]}>
               
                       {(arr_id_referenceNumber, { add, remove }) => (
                       <>
                       {/* <Row  style={{width:'100%'}}><Col span={18}></Col>
                      <Col style={{textAlign:'right'}} span={6}>
                      <Button style={{position:'absolute',top:-95,right:10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button>
                      </Col>
                      </Row> */}
                       {arr_id_referenceNumber.map(({ key, name, fieldKey, ...brestField }) => (
                       <Form.Item
                       {...brestField}
                       name={[name,'id_referenceNumber']}
                       rules={[{ required: true, message: 'Reference No is required' }]}
                        requiredMark={'optional'}
                         style={{ display: 'inline-block', width: key==0?'calc(50% - 8px)':'99%', margin: key==0?'0 8px':0 }}
                         label={key==0?<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}> <Button style={{marginBottom:-5,marginTop:-10,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()}  type="link">+ ADD</Button></Col></Row>:<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col span={6} style={{textAlign:'right'}}><MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                       //style={{ display: 'inline-block', width: '98%', margin: '0 8px' }}
                       //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right',paddingRight:1}} span={6}>&nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                       >
                       <Input className="formInput" placeholder="" />
                       </Form.Item>
                       ))}
               
                       </>
                       )}
               
                       </Form.List>
               
                       </Form.Item>
               
                       <Form.Item
                       {...restField}
                       name={[name, 'id_description']}
                       label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                       >
                       <TextArea rows={4} className="formInput" placeholder="" />
                       </Form.Item>
                       <>
                       </>
                       </>
                   ))}
                 </>
               )}
               </Form.List>
               </>
              }
             </>
           
            </Col>
          </Row>
        
         <Row  style={{paddingTop:24,paddingBottom:24,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb',marginBottom:10}}>
         <Col span="6"></Col>
         <Col span="11" style={{textAlign:'right',marginLeft:12}}>
         <Space>
           <Link to="/departments">
           <Button  type="primary" size="large" ghost>Cancel</Button>
           </Link>
       
         <Button htmlType="submit" type="primary" size="large" >Submit</Button>
       </Space>
         </Col>
         <Col span="6"></Col>
         
         </Row>
         </Form>
        </div>

  </div>
 
  </div>
  </Container>
    </>
  );
}
